import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { LuCircleMinus } from 'react-icons/lu'

/**
 * Detach on a row of a network's members or of a node's networks: a circled minus, "remove from
 * this group", which does not read as delete. The click opens the attach dialog, which asks first.
 */
export default function DetachButton({
  network,
  onClick,
}: Readonly<{ network: string | undefined; onClick: () => void }>) {
  const label = network ? `Detach from ${network}` : 'Detach'
  return (
    <Tooltip title={label}>
      <IconButton
        size="small"
        aria-label={label}
        onClick={onClick}
        sx={{ color: 'text.secondary', '&:hover': { color: 'primary.main' } }}
      >
        <LuCircleMinus />
      </IconButton>
    </Tooltip>
  )
}
